// accessControl.js

export const ACCESS = {
  "Yvooa SelfManage": {
    Landlord: {},
    "Property Manager": {},
  },
  "Yvooa ProPM": {
    "Client Admin": {},
    "Property Manager": {},
  },
};

export const getAccess = (productLine, role) => {
  return ACCESS[productLine]?.[role] || {};
};

export const isSelfManageProduct = (productLine) => {
  return productLine === "Yvooa SelfManage";
};

export const isProPmProduct = (productLine) => {
  return productLine === "Yvooa ProPM";
};

export const isLandlord = (role) => {
  return role === "Landlord";
};

export const isClientAdmin = (role) => {
  return role === "Client Admin";
};

// Can be of Both Product Lines
export const isPropertyManager = (role) => {
  return role === "Property Manager";
};

export const isAsstPropertyManager = (role) => {
  return role === "Assistant Property Manager";
};

export const isTenant = (role) => {
  return role === "Tenant";
};

export const isSingleFamily = (type) => {
  return type === "Single Family";
};

export const isMultiFamily = (type) => {
  return type === "Multi-Family";
};
